import React, { useEffect } from "react";
import { useQuery } from "react-query";
import { Company, Scope } from "../models";
import ReportsService from "../service/ReportsService";
import { View360ReportTable } from "view360Card/components/view360ReportTable/View360ReportTable";
import pl from "shared/messages/pl";
import FailedToFetchReportError from "../error/FailedToFetchReportError";

export interface CompanyCustomersSubSectionProps {
    intermediaryId: number;
    scope: Scope | undefined;
    company: Company;
    selectedSegments: string[];
    selectedYears: string[];
    selectedMode: string;
}

export const CompanyCustomersSubSection: React.FC<CompanyCustomersSubSectionProps> = (props) => {
    const queryKey = `customers_${props.company.code}`;

    const { isFetching, isError, data, refetch } = useQuery(queryKey, async () => {
        return await ReportsService.getCustomersReport(
            props.intermediaryId,
            props.scope,
            props.company.code,
            props.selectedSegments,
            props.selectedYears,
            props.selectedMode
        );
    });

    useEffect(() => {
        const init = async () => {
            await refetch();
        };

        init();
    }, [props.scope?.code, props.selectedSegments, props.selectedYears, props.selectedMode]);

    if (isError) {
        return (
            <FailedToFetchReportError
                message={pl.view360Card.reports.errors.failedToFetchCustomerReportErrorMessage(props.company.name)}
            />
        );
    }

    return <View360ReportTable reportData={data} />;
};
